var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user_trash"},[_c('Table',_vm._b({attrs:{"data":_vm.user_trashes},on:{"on-action":_vm.handleActions},scopedSlots:_vm._u([{key:"created_at",fn:function(ref){
var row = ref.row;
return [_c('strong',{staticClass:"tx-small"},[_vm._v(_vm._s(_vm.dayjs(row.created_at).format('DD-MM-YYYY HH:mm')))])]}}])},'Table',_vm.Model.tables.user_trash.props,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }